import { TweenLite, Power0, Power2, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import nunjucks from 'nunjucks'
import 'gsap/ScrollToPlugin'
// import flickityHelpers from '../util/flickityHelpers' // Not needed if we remove the custom scroll logic
const Flickity = require('flickity')
require('flickity-bg-lazyload')

class Helpers {
  constructor () {
    this.toggleSearchForm = this.toggleSearchForm.bind(this)
    this.openPressPopup = this.openPressPopup.bind(this)
    this.closePressPopup = this.closePressPopup.bind(this)
    this.helperTimeline = new TimelineMax()
    this.pressPopup = {
      $el: $('.press-popup'),
      template: $('.press-popup-template').remove().html(),
    }
  }

  scrollDown () {
    TweenLite.to($(window), 0.6, {
      scrollTo: $(window).height(),
      ease: Power2.easeInOut,
    })
  }

  toggleSearchForm ($link, open) {
    const $searchForm = $('.search-form')

    if ($searchForm.data('isAnimating')) {
      return
    }

    const isOpen = $searchForm.hasClass('open')

    open = (typeof open === 'undefined') ? !isOpen : open

    if (isOpen === open) {
      return
    }

    $searchForm
      .toggleClass('open', open)
      .data('isAnimating', true)

    if (open) {
      this.helperTimeline
        .clear()
        .set($searchForm, { height: 'auto', immediateRender: true })
        .from($searchForm, 0.6, { height: '0px', ease: Power3.easeInOut })
        .to($searchForm, 0.3, {
          autoAlpha: 1,
          ease: Power0.easeNone,
          onComplete: () => {
            $searchForm
              .data('isAnimating', false)
              .find('input')
              .focus()
              .one('blur', () => {
                this.toggleSearchForm(null, false)
              })
          },
        }, 0.45)
    } else {
      this.helperTimeline
        .clear()
        .to($searchForm, 0.6, { height: '0px', ease: Power3.easeInOut }, 0.15)
        .to($searchForm, 0.3, { autoAlpha: 0, ease: Power0.easeNone, onComplete: () => { $searchForm.data('isAnimating', false) } }, 0)
    }
  }

  openPressPopup (data) {
    const renderedHTML = nunjucks.renderString(this.pressPopup.template, data)
    this.pressPopup.$el.find('.press-popup__content').html(renderedHTML)

    const $images = this.pressPopup.$el.find('.image')

    if ($images.length > 1) {
      // Initialize Flickity
      const flkty = new Flickity(this.pressPopup.$el.find('.press-popup__slider__inner').get(0), {
        wrapAround: false,
        pageDots: false,
        prevNextButtons: true,
        // bgLazyLoad: 2, // <--- DISABLE THIS. We will load images via CSS to fix the 404s
        arrowShape: {
          x0: 10,
          x1: 50,
          y1: 40,
          x2: 50,
          y2: 33,
          x3: 17,
        },
      })

      // Force resize to fix layout bugs on open
      setTimeout(() => {
        flkty.resize()
      }, 300)

    } else if ($images.length === 1) {
       // Handle single image
       // Check if data-background-image exists, otherwise use the style attribute
       const bg = $images.first().attr('style'); 
       if (!bg || bg.indexOf('background-image') === -1) {
         const src = $images.first().data('src');
         if(src) TweenLite.set($images.first(), { backgroundImage: `url(${src})` });
       }
    }

    TweenLite.fromTo(this.pressPopup.$el, 0.3, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeNone })
  }

  closePressPopup () {
    TweenLite.to(
      this.pressPopup.$el,
      0.3,
      {
        autoAlpha: 0,
        ease: Power0.easeNone,
        onComplete: () => {
          this.pressPopup.$el.find('.press-popup__content').empty()
        },
      }
    )
  }
}

export default Helpers


// WEBPACK FOOTER //
// ./scripts/util/helpers.js